import React, { useState } from "react";
import { Button } from "reactstrap";

import ScrollButtonFile from "../assets/icons/top-button.svg";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <img
      src={ScrollButtonFile}
      id="scroll-top-button"
      alt="scroll-button"
      style={{ display: visible ? "inline" : "none" }}
      onClick={scrollToTop}
    />
  );
};

export default ScrollButton;
